import { createContext, useEffect, useState } from "react";
import {
  LOCAL_STORAGE_DATA,
  LocalStorageController,
} from "../utils/LocalStorageController";
import React from "react";
const ThemeContext = createContext({
  theme: "light",
  toggleTheme: (newTheme: any) => {},
});
const getCurrentTheme = () =>
  window.matchMedia("(prefers-color-scheme: dark)").matches;

export const ThemeProvider = ({ children }: { children: any }) => {
  const colorSchemeIsBlack = getCurrentTheme();
  const [theme, setTheme] = useState(colorSchemeIsBlack ? "dark" : "light");

  useEffect(() => {
    // Load saved theme from storage
    const getTheme = async () => {
      try {
        const savedTheme = LocalStorageController.connect().getData(
          LOCAL_STORAGE_DATA.THEME,
          "string"
        );
        if (savedTheme) {
          setTheme(savedTheme as any);
        }
      } catch (error) {}
    };
    getTheme();
  }, []);

  const reactToSystemThemeChange = async (e: any) => {
    const memoryTheme = LocalStorageController.connect().getData(
      LOCAL_STORAGE_DATA.THEME,
      "string"
    );
    if (memoryTheme) {
    } else {
      setTheme(e.matches ? "dark" : "light");
    }
  };
  useEffect(() => {
    const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
    darkThemeMq.addEventListener("change", reactToSystemThemeChange);
    return () =>
      darkThemeMq.removeEventListener("change", reactToSystemThemeChange);
  }, []);

  const toggleTheme = (newTheme: any) => {
    setTheme(newTheme);
  };
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
export default ThemeContext;
